var startsida = (function () {
  function flyttaToppbildfotograf(toppbildlankar) {
    if (window.innerWidth <= window.mdMax) {
      let height = toppbildlankar.offsetHeight;
      let toppbildfotografwrapper = document.querySelector(
        ".toppbildwrapper.mobil .toppbildfotografwrapper"
      );
      if (toppbildfotografwrapper) {
        let bottom = height / 2 + 16;
        toppbildfotografwrapper.style.bottom = bottom + "px";
      }
    }
  }

  /* ********** Exponerade funktioner     */
  function initStartsida() {
    let toppbildlankar = document.getElementById("toppbildlankar");
    if (toppbildlankar) {
      flyttaToppbildfotograf(toppbildlankar);
      window.addEventListener("resize", () => {
        flyttaToppbildfotograf(toppbildlankar);
      });
    }
  }

  return {
    initStartsida: initStartsida,
  };
})();

export default startsida;
